import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BaiduMapModule } from "angular2-baidu-map";

import { BannerComponent } from './banner/banner.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BaiduComponent } from './baidumap/baidumap.component';

@NgModule({
  declarations: [
    BannerComponent,
    HeaderComponent,
    FooterComponent,
    BaiduComponent
  ],
  imports: [
  	RouterModule,
    CommonModule,
    BaiduMapModule,   
  ],
  exports: [ 
    BannerComponent,
    HeaderComponent,
    FooterComponent,
    BaiduComponent
  ] 
})
export class CommentModule {}



// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/comment/comment.module.ts